import {Picture} from '@app/_components/picture';
import {ImapConfiguration} from '@app/_components/imap-configuration/imap-configuration';

export class Inbox {
  msgId: number;
  createDate: Date;
  taskAPI: any;
  msgFolder: number;
  msgOrigin: number;
  senderEmail: string;
  senderName: string;
  subject: string;
  taskAPIList: any[];
  emailHtml: string;
  emailText: string;
  senderMobileNum: string;
  senderCountryCode: string;
  mobileText: string;
  statusMsg: string;
  topicId: string;
  topic: string;
  pictures: Picture[];
  msgRecipientAPIList: any[];
  topicPurpose: number;
  imapConfigurationAPI: ImapConfiguration;
  msgConversationId: number;
}
